export enum ComplianceRequestType {
    TERMS_AND_CONDITIONS_ACCEPTANCE = 'TERMS_AND_CONDITIONS_ACCEPTANCE',
    ACCEPTABLE_USE_POLICY_ACCEPTANCE = 'ACCEPTABLE_USE_POLICY_ACCEPTANCE',
    PRIVACY_POLICY_ACCEPTANCE = 'PRIVACY_POLICY_ACCEPTANCE',
    WM_DIFC_REGULATED_CONFIRMATION = 'WM_DIFC_REGULATED_CONFIRMATION',
    RM_DFSA_RELEVANT_INDIVIDUAL_SELF_CONFIRMATION = 'RM_DFSA_RELEVANT_INDIVIDUAL_SELF_CONFIRMATION',
    CLIENT_PROFESSIONAL_CLIENT_CONFIRMATION = 'CLIENT_PROFESSIONAL_CLIENT_CONFIRMATION',
}

export interface ComplianceRequest {
    type: ComplianceRequestType;
    createdAt?: string;
}

export interface PendingComplianceRequestsResponse {
    requests: ComplianceRequest[];
}
